import { type NotificationType } from '@/redux/slices/notificationSlice'
import type { SmsContentAuditRejectedActivity } from '@/typings/domain'
import ItemWrapper from './ItemWrapper'

export default function SmsContentAuditRejected({ notification }: { notification: NotificationType }) {
  const activity = notification.activity as SmsContentAuditRejectedActivity
  const formInfo = activity.formInfo

  if (!formInfo) return null

  return <ItemWrapper notification={notification}>《{formInfo.formName}》因内容涉嫌违规,短信发送失败</ItemWrapper>
}
